import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ActionCtor } from '../../store/modules/main';

const InitializeContainer = () => {
  const { phone } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(ActionCtor.setFavorite());
  }, [dispatch, phone]);

  return null;
};

export default InitializeContainer;
